import React, { ReactNode } from "react"

export type Review = {
  name: string
  rating: string
  title: ReactNode
  description: ReactNode
  footerText: string
}

export const REVIEWS_DEFAULT: Review[] = [
  {
    name: "Екатерина",
    rating: "5.0",
    title: <>Пользуюсь с&nbsp;удовольствием, всем рекомендую</>,
    description: (
      <>
        Карта халва — это много возможностей, пользуюсь с&nbsp;удовольствием, рекомендую всем.
        С&nbsp;каждым уровнем увеличиваются возможности, бесплатные переводы клиенту любого банка ,
        если подключена услуга халва-десятка, кешбек, начисление процента на&nbsp;остаток средств,
        за&nbsp;каждый месяц.
      </>
    ),
    footerText: "Москва, 21.05.25",
  },
  {
    name: "Жанна",
    rating: "5.0",
    title: <>C картой Халва уже 1.5 года и&nbsp;в&nbsp;полном восторге! </>,
    description: (
      <>
        Не&nbsp;нашла ни&nbsp;одного минуса!!! Одни плюсы!!! По-любому вопросу облагаюсь
        в&nbsp;онлайн-чат банка и всегда грамотно и&nbsp;доходчиво все объясняют и&nbsp;помогают
        разобраться в&nbsp;сложившейся ситуации ! Очень всем рекомендую Совкомбанк и&nbsp;Халву!
      </>
    ),
    footerText: "Омск, 03.10.23",
  },
  {
    name: "Леонид",
    rating: "4.8",
    title: <>Снимаю деньги где угодно плюс хороший кэшбэк</>,
    description: (
      <>
        Нужно следить за&nbsp;акциями. Удобно, что&nbsp;можно снимать деньги в&nbsp;любых
        банкоматах. Хороший кэшбэк и&nbsp;%&nbsp;на&nbsp;остаток. Кредитные программы, можно
        подобрать с&nbsp;низкой % ставкой. Персонал внимательный, банк всегда идёт на&nbsp;встречу
        клиенту.
      </>
    ),
    footerText: "Казань, 17.02.26",
  },
  {
    name: "Марина",
    rating: "5.0",
    title: <>Закрыла все карты одной Халвой</>,
    description: (
      <>
        Очень нравится карта халва. Можно пользоваться как заемными средствами, так
        и&nbsp;собственными. С&nbsp;подпиской халва десятка можно без процентов переводить деньги
        в&nbsp;другие банки. А&nbsp;при соблюдении минимального оборота деньги за&nbsp;подписку
        возвращаются. Убрала все свои карты и&nbsp;полностью перешла на&nbsp;халву. Она заменяет все
        карты
      </>
    ),
    footerText: "Санкт‑Петербург, 14.03.25",
  },
  {
    name: "Андрей",
    rating: "4.5",
    title: <>Кэшбэк рублями и&nbsp;процент на&nbsp;остаток в&nbsp;одной карте</>,
    description: (
      <>
        Кэшбэк переводится в&nbsp;реальные рубли, беспроцентная рассрочка, бесплатные доставка,
        обслуживание, оформление, начисляется процент на&nbsp;остаток. Из&nbsp;недостатков
        магазинов-партнеров кэшбэк начислялся при чеке от&nbsp;1000 рублей
      </>
    ),
    footerText: "Владивосток, 03.07.23",
  },
  {
    name: "Оксана",
    rating: "5.0",
    title: <>Взяла по&nbsp;совету и&nbsp;до&nbsp;сих&nbsp;пор не&nbsp;жалею</>,
    description: (
      <>
        С&nbsp;картой халва столкнулась впервые. В&nbsp;торговом центре представитель банка
        порекомендовал взять карту. Очень вежливо все рассказала, все условия договора. Сейчас
        до&nbsp;сих&nbsp;пор пользуюсь, претензий никаких нет. Очень удобный мобильный банк, все
        четко и&nbsp;понятно
      </>
    ),
    footerText: "Екатеринбург, 22.11.24",
  },
]
